module.exports = __webpack_public_path__ + "img/monespacesante.85c1cf06.svg";